import { useCallback, useEffect, useRef, useState } from 'react';

export default function useShowBtnHooks({
  loading,
  minHeight = 300,
  maxWith = 1920,
}: any) {
  const cardListRef = useRef<any>(null);
  const [isShowBtn, setIsShowBtn] = useState(false);
  const [isMaxInnerWith, setIsMaxInnerWith] = useState(false);
  const getListSize = useCallback(() => {
    const newHeight = cardListRef?.current?.scrollHeight;
    setIsShowBtn(newHeight > minHeight);
    setIsMaxInnerWith(window.innerWidth >= maxWith);
  }, []);

  useEffect(() => {
    getListSize();
  }, [loading]);

  useEffect(() => {
    window.addEventListener('resize', getListSize);

    return () => {
      window.removeEventListener('resize', getListSize);
    };
  }, [getListSize]);

  const [showMore, setShowMore] = useState(false);
  const clickShowMore = () => {
    setShowMore(!showMore);
  };

  return {
    isShowBtn,
    cardListRef,
    showMore,
    clickShowMore,
    isMaxInnerWith,
  };
}
